import React from 'react';
import styles from './EmptyConversationCard.module.scss';
import botIcon from '../../../../../../assets/image/bot-icon-rounded-white.svg';
import { useFormikContext } from 'formik';

const EmptyConversationCard = () => {
  const { values } = useFormikContext();
  function adjustColor(hex, percent) {
    if (!hex) return '';
    hex = hex.replace(/^#/, '');
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);
    r = Math.min(255, Math.max(0, r + (255 - r) * percent));
    g = Math.min(255, Math.max(0, g + (255 - g) * percent));
    b = Math.min(255, Math.max(0, b + (255 - b) * percent));
    const toHex = (c) => {
      const h = Math.round(c).toString(16);
      return h.length === 1 ? '0' + h : h;
    };
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  }

  return (
    <div className={styles['conversation-card']}>
      <div className={styles['card-wrapper']}>
        <div className={styles['card-body']}>
          <div
            className={styles['ask-btn']}
            style={{
              background:
                values?.GreetingStyle?.toLowerCase?.() === 'basic'
                  ? values?.GreetingAccentColor || '#0957d0'
                  : values?.GreetingAccentColor
                  ? `linear-gradient(
            90deg,
            ${values.GreetingAccentColor} 0%,
            ${adjustColor(values.GreetingAccentColor, 0.6)} 49.04%,
            ${adjustColor(values.GreetingAccentColor, 0.4)} 100%
          )`
                  : undefined,
            }}
          >
            <img src={botIcon} alt='bot-icon' />
            <p className={styles['ask-text']}>{values?.GreetingMessage}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyConversationCard;
